import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  private previousPageData: any;

  setData(data: any) {
    this.previousPageData = data;
  }

  getData() {
    return this.previousPageData;
  }
}
